import { BraintreeCreditCardType, InvoicePaymentMethod, InvoiceStatus } from '../models/graphql';
import { BadgeColorsEnum } from '../constants/badge';
import React from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { showToast } from './showToast';
import { PDFSizeEnum } from '../modules/Settings/Invoice/Invoice.view';

export const getBadgeColor = (status: InvoiceStatus) => {
  switch (status) {
    case InvoiceStatus.PAID:
      return BadgeColorsEnum.SELECT;
    case InvoiceStatus.FAILED:
      return BadgeColorsEnum.RED20;
    case InvoiceStatus.REFUNDED:
      return BadgeColorsEnum.GREEN15;
    default:
      return BadgeColorsEnum.GREY20;
  }
};

export const getPaymentMethod = (method: InvoicePaymentMethod, creditCard?: BraintreeCreditCardType) => {
  switch (method) {
    case InvoicePaymentMethod.PAYPAL_ACCOUNT:
      return 'Paypal';
    case InvoicePaymentMethod.APPLE_PAY_CARD:
      return 'Apple Pay';
    case InvoicePaymentMethod.CREDIT_CARD:
      return creditCard?.type || 'Credit Card';
    default:
      return method;
  }
};

export const handleDownloadPDF = async (
  invoiceRef: React.MutableRefObject<HTMLDivElement | null>,
  invoiceId: string | number,
  pdfSize?: PDFSizeEnum
) => {
  const input = invoiceRef.current;
  if (!input) return;

  try {
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');

    const pdf = pdfSize === PDFSizeEnum.LETTER ? new jsPDF('p', 'px', 'letter') : new jsPDF('p', 'px', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    // calculate the new height of the image to maintain its aspect ratio relative to the PDF width
    let newHeight = (pageWidth * imgHeight) / imgWidth;
    let newWidth = pageWidth;

    // if the new height is greater than the page height, scale both width and height proportionally
    if (newHeight > pageHeight) {
      const ratio = pageHeight / newHeight;
      newHeight = pageHeight; // set the height to page height
      newWidth *= ratio; // scale the width
    }

    pdf.addImage(imgData, 'PNG', 0, 0, newWidth, newHeight);
    pdf.save(`SmarterQueue_Invoice_${invoiceId}.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
    showToast({
      severity: 'error',
      summary: 'Unable to create PDF of the invoice',
      detail: 'There was a problem generating the PDF of the invoice. Please try again, or contact us.'
    });
  }
};

export const rateChargedToPercentage = (value: string | number): string => {
  let numericValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numericValue)) {
    // How should we handle this?
    numericValue = 0;
  }

  return `${numericValue}%`;
};
